import { createAction } from '@reduxjs/toolkit';

export const IN_CALL_CONTACTS_FILTERED_BY_ACTION_TYPE = 'saga/inCallContactsFilteredBy';
export const inCallContactsFilteredByAction = createAction(IN_CALL_CONTACTS_FILTERED_BY_ACTION_TYPE);
